<template>
	<v-container>
		<v-row class="contentRow">
			<v-col cols="12">
				<h1 class="mb-2">Update Action Plan</h1>
			</v-col>

			<v-col align="center">
				<v-form v-model="valid">
					<v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Mitigation" v-model="connections[0].Mitigation" :rules="[rules.inputRules]" />
						</v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Description" v-model="connections[0].Description"
								:rules="[rules.inputRules, rules.maxWords]" />
						</v-col>
						<v-col>
							<v-text-field outlined width="50%" label="Connected to risk" v-model="connections[0].Connected_to_risk"
								:rules="[rules.inputRules]" />
						</v-col>
						<!-- <v-col>
							<v-text-field outlined label="Status" v-model="Status" :rules="[rules.inputRules]" />
						</v-col> -->
						<v-col>
							<v-select
								label="Status"
								v-model="connections[0].Status"
								:items="options"
								item-value="id"
								item-text="text"
								:rules="[rules.inputRules]"
								outlined
							>
							</v-select>
						</v-col>
						<v-col>
							<v-text-field outlined label="Assigned" v-model="connections[0].Assigned"
								:rules="[rules.inputRules]" />
						</v-col>
						<v-col>
							<v-text-field type="date" outlined label="Created" v-model="connections[0].Created" :rules="[rules.inputRules]" />
						</v-col>
						<v-col>
							<v-text-field type="date" outlined label="Expired date"
								v-model="connections[0].ExpiryDate" :rules="[rules.inputRules]" />
						</v-col>
						<!-- <v-col>
						<v-alert color="primary" type="info">
							Note: <b>{{ (risk || riskdescription) ? risk + " " + riskdescription : "The new user" }}</b> must
							verify their e-mail address before logging in. A verification e-mail will be sent to
							<b>{{ typesofrisk || "their e-mail" }}</b> when you click 'Add user'
						</v-alert>
					</v-col> -->
						<v-col>
							<v-btn class="mr-10" color="primary"
								@click="updateAction(connections[0].ActionPlanID, connections[0].Mitigation, connections[0].Description, connections[0].Connected_to_risk, connections[0].Status, connections[0].Assigned, connections[0].Created, connections[0].ExpiryDate)"
								:disabled="!valid">
								Update Action Plan</v-btn>
						</v-col>
					</v-col>
				</v-form>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { actionplanAPI } from "../api/csr/actionplan"
import LoadingState from "../consts/LoadingState"

export default {
	name: "Add user",
	data() {
		return {
			ActionPlanID: "",
			itemId: null,
			connections: [],
			show: false,
			valid: false,
			connected_to_risk: "",
			status: 0,
			expiryDate: "",
			assigned: "",
			created: "",
			mitigation: "",
			description: "",
			rules: {
				inputRules: v => !!v || "Field is required!",
				maxWords: v => (v.split(/\s+/).length <= 30) || "Risk description can only contain up to 30 words"
			},
			options: [
				{ id: 1, text: "Done"},
				{ id: 2, text: "Started"},
				{ id: 3, text: "Planned"}
			],
		}
	},
	mounted() {
		this.itemId = this.$route.query.itemId
		console.log(this.itemId)
		this.loadActiondata()
		this.$store.commit("setSelectedNewstate", true)
	},
	methods: {
		updateAction(ActionPlanID, mitigation, description, connected_to_risk, status, assigned, created, expiryDate) {
			// this.$store.dispatch(
			// 	"loading/" + LoadingState.ACTION_START_LOADING,
			// 	{ root: true }
			// )

			alert("action updated")

			actionplanAPI.updateActionById(ActionPlanID, mitigation, description, connected_to_risk, status, assigned, created, expiryDate)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Sucessfully Updated Action!",
						{ root: true }
					)
					this.$router.push({ name: "riskpage" })
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadActiondata() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			actionplanAPI.getActionById(this.itemId)
				.then((data) => {
					let entry1 = data[0]
					let entry = entry1[0]
					console.log(entry)
					this.connections.push({
						ActionPlanID: entry.ActionPlanID,
						Mitigation: entry.Mitigation,
						Description: entry.Description,
						Connected_to_risk: entry.Connected_to_risk,
						Status: entry.Status,
						Assigned: entry.Assigned,
						Created: entry.Created.split("T")[0],
						ExpiryDate: entry.ExpiryDate.split("T")[0],
					})
					// Can't make a check inside for loop (eslint), have to remove it outside. Not a good fix.
					/*					this.connections = this.connections.filter(function (obj) {
						return obj.clientID !== 1 // clientID 1 is the user (client accessing the portal).
					}) */
					// Used by old method of showing sustainability
					//this.averageScore() // Calculating average score of all suppliers 
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					console.log("I am here in update")
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		}
	}
}
</script>